import { render, staticRenderFns } from "./TechGroup.vue?vue&type=template&id=e8888e82&"
import script from "./TechGroup.vue?vue&type=script&lang=js&"
export * from "./TechGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports